import { ServiceMaker, methods, services } from "../services";

export const fetchListOfCriteria = (payload) =>
    ServiceMaker(
        `/batch-processor/criteria/list?status=${payload.status}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&page=${payload.page}&limit=${payload.limit}`,
        methods.GET,
        services.master,
    );

export const fetchEntitiesList = (payload) =>
    ServiceMaker(
        `/batch-processor/entities/list?label=${payload.label}`,
        methods.GET,
        services.master,
    );

export const createNewCriteria = (payload) =>
    ServiceMaker(
        `/batch-processor/criteria/create`,
        methods.POST,
        services.master,
        payload,
    );

export const fetchListTemplateType = (payload) =>
    ServiceMaker(
        `/smsemail/templates?service=${payload.service}`,
        methods.GET,
        services.master,
    );

export const fetchPromoListTemplateType = (payload) =>
    ServiceMaker(
        `/smsemail/templates?service=${payload.service}&concern=${payload.concern}`,
        methods.GET,
        services.master,
    );

export const fetchPreviewTemplate = (payload) =>
    ServiceMaker(
        `/smsemail/templates/detail/${payload.templateId}`,
        methods.GET,
        services.master,
    );

export const fetchcreateBulkNotification = (payload) =>
    ServiceMaker(
        `/batch-processor/bulk-notification/create`,
        methods.POST,
        services.master,
        payload,
    );

export const fetchDataCriteriaById = (payload) =>
    ServiceMaker(
        `/batch-processor/criteria/details/${payload.id}`,
        methods.GET,
        services.master,
    );

export const fetchDataTemplateById = (payload) =>
    ServiceMaker(
        `/batch-processor/bulk-notification/criteria-details/${payload.id}`,
        methods.GET,
        services.master,
    );

export const fetchRequestDownload = (payload) =>
    ServiceMaker(
        `/batch-processor/request-download/list?status=${payload.status}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&type=${payload.type}`,
        methods.GET,
        services.master,
    );

export const createRequestDownload = (payload) =>
    ServiceMaker(
        `/batch-processor/request-download/create`,
        methods.POST,
        services.master,
        payload,
    );
